import MyProductsState, { actions } from '@/pages/MyProducts/MyProducts.redux.js';
import { AppstoreOutlined, ShoppingOutlined } from '@ant-design/icons';
import React, { lazy } from 'react';

import { registerNavigation } from '@/core/navigation';
import { registerReduxStore } from '@/core/store';
import { registerRoutes } from '@/core/routes';

import './MyProducts.sass';

const MyProducts = lazy(() => import('./MyProducts'));



registerReduxStore('myProducts', MyProductsState, actions);


registerRoutes([
	{
		path:        '/my-products',
		exact:       true,
		render:      <MyProducts />,
		title:       'My Products',
		private:     true,
		permissions: [],
	},
]);



registerNavigation({
	title:       'Products',
	permissions: [],
	single:      false,
	top:         true,
	home:        true,
	icon:        <AppstoreOutlined />,
	children:    [
		{
			title:       'View / Reorder',
			url:         '/my-products',
			icon:        <ShoppingOutlined />,
			permissions: [],
		},
	],
});


console.log('Registered My Products Plugin');
